<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="商品一名称：" prop="goods_name1">
                <span>{{model.goods_name1}}</span>
            </el-form-item>
            <el-form-item label="商品一图片：" prop="goods_img1">
                <span>{{model.goods_img1}}</span>
            </el-form-item>
            <el-form-item label="商品一链接：" prop="goods_link1">
                <span>{{model.goods_link1}}</span>
            </el-form-item>
            <el-form-item label="商品二名称：" prop="goods_name2">
                <span>{{model.goods_name2}}</span>
            </el-form-item>
            <el-form-item label="商品二图片：" prop="goods_img2">
                <span>{{model.goods_img2}}</span>
            </el-form-item>
            <el-form-item label="商品二链接：" prop="goods_link2">
                <span>{{model.goods_link2}}</span>
            </el-form-item>
            <el-form-item label="是否显示：" prop="show_state">
                <span>{{model.show_state}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'momentAdInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                goods_name1: '',
                goods_img1: '',
                goods_link1: '',
                goods_name2: '',
                goods_img2: '',
                goods_link2: '',
                show_state: '',
            },
            getObj:{
                url:'/api/admin/momentad/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>